import React, { Component } from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import ImmutableProptypes from 'react-immutable-proptypes'
import { Map, OrderedMap } from 'immutable'
import classnames from 'classnames'
import { browserHistory } from 'react-router'
import Moment from 'moment'
import Modal from 'react-modal'
import { CSVLink } from 'react-csv'

import { searchItems } from '_modules/search/actions'
import {
  deleteTodayItem,
  getTodayItems,
  createTodayItem,
  completeTodayItem,
} from '_modules/today-items/actions'
import { createLogEntryFromToday } from '_modules/log/actions'
import {
  getTomorrowItems,
  createTomorrowItem,
  editTomorrowItem,
  deleteTomorrowItem,
  checkTomorrowItem,
} from '_modules/tomorrow-items/actions'
import { updateLastActivityAt } from '_modules/user/actions'
import { checkReconcileItem } from '_modules/reconcile/actions'
import { createGoogleCalendarURL, createICalendarEvent } from '_utils/addToCalendar'
import { objectToArray } from '_utils/helperFunction'

import CalendarModal from './calendar-modal'
import EventFormModal from './event-form-modal'
import TodayCard from './today-card'
import TasksCard from './tasks-card'
import LogCard from './log-card'
import styles from './styles.css'

const mapStateToProps = ({ search, settings, tomorrowItems, todayItems }) => ({
  search,
  settings,
  tomorrowItems,
  todayItems,
})

const mapDispatchToProps = {
  searchItems,
  checkReconcileItem,
  deleteTodayItem,
  getTomorrowItems,
  createTomorrowItem,
  updateLastActivityAt,
  editTomorrowItem,
  deleteTomorrowItem,
  checkTomorrowItem,
  getTodayItems,
  createTodayItem,
  createLogEntryFromToday,
  completeTodayItem,
}

class Search extends Component {
  static propTypes = {
    search: ImmutableProptypes.map,
    settings: ImmutableProptypes.map,
    tomorrowItems: ImmutableProptypes.map,
    todayItems: ImmutableProptypes.map,
    searchItems: PropTypes.func.isRequired,
    checkReconcileItem: PropTypes.func.isRequired,
    deleteTodayItem: PropTypes.func.isRequired,
    getTomorrowItems: PropTypes.func.isRequired,
    createTomorrowItem: PropTypes.func.isRequired,
    updateLastActivityAt: PropTypes.func.isRequired,
    editTomorrowItem: PropTypes.func.isRequired,
    deleteTomorrowItem: PropTypes.func.isRequired,
    checkTomorrowItem: PropTypes.func.isRequired,
    getTodayItems: PropTypes.func.isRequired,
    createTodayItem: PropTypes.func.isRequired,
    createLogEntryFromToday: PropTypes.func.isRequired,
    completeTodayItem: PropTypes.func.isRequired,
  }

  static defaultProps = {
    search: new OrderedMap(),
    settings: new Map(),
    tomorrowItems: new Map(),
    todayItems: new OrderedMap(),
  }

  state = {
    isModalOpen: false,
    isCalendarModal: false,
    isEventFormModal: false,
    csvData: [],
    csvFilename: 'search',
  }

  componentDidMount() {
    const { queryString } = this.props.location.query

    if (queryString) {
      this.props.searchItems(queryString)
    }
  }

  componentWillReceiveProps(nextProps) {
    const { queryString } = nextProps.location.query

    if (this.props.location.query.queryString !== queryString) {
      this.props.searchItems(queryString)
    }
  }

  // TODO: Status to be implemented in the future
  checkTodayCard = (logId, todayItemId, name, keptAt, status) => {
    const time = new Date()
    if (status === 2) {
      const payload = {
        name,
        type: 3,
        time,
        status,
        logEntry: logId,
        todayItem: todayItemId,
      }
      this.props.completeTodayItem(payload)
    } else {
      let payload = {
        name,
        type: 3,
        time,
        status,
        logEntry: logId,
        todayItem: todayItemId,
      }
      if (status === 0) {
        payload.time = keptAt
      }
      this.props.createLogEntryFromToday(payload)
    }
    this.props.updateLastActivityAt({
      lastActivityAt: new Date(),
    })
    this.props.searchItems(this.props.location.query.queryString)
  }

  checkTomorrowCard = (name, id) => {
    const now = new Date()
    const { todayItems } = this.props
    const order = objectToArray(todayItems.toJS()).reduce((prevVal, c) => {
      if (c.order > prevVal) {
        return c.order
      }
      return prevVal
    }, 0)
    const foundSameCard = objectToArray(todayItems.toJS()).filter(
      x =>
        x.name.toLowerCase() === name.toLowerCase() &&
        new Date(x.keptAt).setHours(0, 0, 0, 0) === new Date().setHours(0, 0, 0, 0)
    )

    if (foundSameCard.length > 0) {
      // this.props.displayError('Today item with the same name already exists')
    } else {
      const payload = {
        time: now,
        name,
        order: order + 1,
        tomorrowId: id,
      }

      this.props.checkTomorrowItem(payload)
      this.props.getTodayItems()
      this.props.updateLastActivityAt({
        lastActivityAt: new Date(),
      })
    }
    this.props.searchItems(this.props.location.query.queryString)
  }

  playCard = (name, logId, todayItemId) => {
    const { settings } = this.props
    if (logId) this.props.checkReconcileItem({ logId })
    if (todayItemId) this.props.deleteTodayItem(todayItemId)

    const flexibleTime = settings.get('flexibleTime')

    browserHistory.push({
      pathname: '/',
      state: {
        name,
        action: 'start',
        logEntry: logId || null,
        flexibleTime,
      },
    })
  }

  deleteTodayCard = todayItemId => {
    this.props.deleteTodayItem(todayItemId).then(() => {
      this.props.searchItems(this.props.location.query.queryString)
    })
  }

  deleteTomorrowCard = id => {
    this.props.deleteTomorrowItem({ id }).then(() => {
      this.props.searchItems(this.props.location.query.queryString)
    })

    this.props.updateLastActivityAt({
      lastActivityAt: new Date(),
    })
  }

  createTomorrowItemCard = (name, sectionId, todayItemId, logId) => {
    const { tomorrowItems } = this.props
    // find last order in tomorrowItems
    const order = tomorrowItems.reduce((prevVal, c) => {
      if (c.order > prevVal) {
        return c.order
      }
      return prevVal
    }, 0)

    const payload = {
      name,
      order: order + 1,
      section: sectionId,
    }

    this.props.createTomorrowItem(payload)
    this.props.getTomorrowItems()

    // this.markLogAsCompleteandDeleteToday(logId, todayItemId)
    this.props.deleteTodayItem(todayItemId).then(() => {
      this.props.searchItems(this.props.location.query.queryString)
    })

    this.props.updateLastActivityAt({
      lastActivityAt: new Date(),
    })
  }

  createCalendarCard = name => {
    this.setState({
      isCalendarModal: true,
      isModalOpen: true,
      modalName: name,
    })
  }

  handleCalendarClick = type => {
    const { modalName: name, modalDatetime: datetime, modalDuration: duration } = this.state
    switch (type) {
      case 'gcal': {
        const url = createGoogleCalendarURL({ name })
        window.open(url, '_blank')
        this.resetState()
        break
      }
      case 'apple':
        this.setState({
          isCalendarModal: false,
          isEventFormModal: true,
          modalDatetime: new Moment().add(1, 'hours'),
        })
        break
      case 'outlook':
        this.setState({
          isCalendarModal: false,
          isEventFormModal: true,
          modalDatetime: new Moment().add(1, 'hours'),
        })
        break
      case 'ics':
        createICalendarEvent({ name, datetime, duration })
        this.resetState()
        break
      default:
    }
  }

  shiftTomorrowCard = (id, name, section) => {
    const { todayItems } = this.props
    // find last order in todayItems
    const order = objectToArray(todayItems.toJS()).reduce((prevVal, c) => {
      if (c.order > prevVal) {
        return c.order
      }
      return prevVal
    }, 0)

    const foundSameCard = objectToArray(todayItems.toJS()).filter(
      x =>
        x.name.toLowerCase() === name.toLowerCase() &&
        new Date(x.keptAt).setHours(0, 0, 0, 0) === new Date().setHours(0, 0, 0, 0)
    )

    if (foundSameCard.length > 0) {
      // this.props.displayError('Today item with the same name already exists')
    } else {
      const payload = {
        name,
        order: order + 1,
      }

      this.props.createTodayItem(payload)

      //delete if not recurring task
      if (section !== 0) {
        this.props.deleteTomorrowItem({ id })
      }
      this.props.updateLastActivityAt({
        lastActivityAt: new Date(),
      })
    }
    this.props.searchItems(this.props.location.query.queryString)
  }

  moveToSectionCard = (id, name, order, section) => {
    const payload = {
      id,
      name,
      order,
      section,
    }
    this.props.editTomorrowItem(payload).then(() => {
      this.props.searchItems(this.props.location.query.queryString)
    })

    this.props.updateLastActivityAt({
      lastActivityAt: new Date(),
    })
  }

  viewDetailsCard = id => {
    browserHistory.push({
      pathname: '/log',
      query: {
        id,
      },
    })
  }

  pressTodayCard = id => {
    browserHistory.push({
      pathname: '/today',
      state: {
        id,
      },
    })
  }

  pressTasksCard = id => {
    browserHistory.push({
      pathname: '/tomorrow',
      state: {
        id,
      },
    })
  }

  onNameChange = e => this.setState({ modalName: e.target.value })

  onDatetimeChange = modalDatetime => this.setState({ modalDatetime })

  onDurationChange = e => this.setState({ modalDuration: e.target.value })

  onKeyPress = event => {
    if (event.key === 'Enter') {
      this.onConfirmModal(event)
    }
  }

  onConfirmModal = () => this.handleCalendarClick('ics')

  onExportClick = () => {
    const { queryString } = this.props.location.query
    const { search, settings } = this.props
    const { todayItems, tomorrowItems, logItems } = search.toJS()

    const sections = {
      0: settings.get('tomorrowSection0'),
      100: settings.get('tomorrowSection1'),
      200: settings.get('tomorrowSection2'),
      300: settings.get('tomorrowSection3'),
      400: settings.get('tomorrowSection4'),
    }

    const csvFilename = `Search Results For ${queryString || 'None'}.csv`

    const todayData = todayItems.map(ti => ({
      Source: 'Today',
      'Task Name': ti.name,
      Date: Moment(ti.createdAt).format('M/D/YYYY'),
      Section: '',
    }))

    const tomorrowData = tomorrowItems.map(ti => {
      return {
        Source: 'Tasks',
        'Task Name': ti.name,
        Date: Moment(ti.createdAt).format('M/D/YYYY'),
        Section: sections[ti.section] || '',
      }
    })

    const logData = logItems.map(l => ({
      Source: 'Log',
      'Task Name': l.name,
      Date: Moment(l.createdAt).format('M/D/YYYY'),
      Section: '',
    }))

    const csvData = todayData.concat(tomorrowData, logData)

    this.setState(
      {
        csvData,
        csvFilename,
      },
      () => {
        if (this.csvLink) {
          this.csvLink.link.click()
          this.resetState()
        }
      }
    )
  }

  resetState = () => {
    this.setState({
      isModalOpen: false,
      isCalendarModal: false,
      isEventFormModal: false,
      csvData: [],
      csvFilename: 'search',
    })
  }

  renderTodayItems = cards => {
    return (
      <div className={styles.sectionContainer}>
        <div className={styles.sectionTitle}> Today</div>
        {cards.map(card => (
          <TodayCard
            key={card._id}
            name={card.name}
            status={card.status}
            logId={card.logEntry}
            todayItemId={card._id}
            keptAt={card.keptAt}
            checkCard={this.checkTodayCard}
            playCard={this.playCard}
            deleteCard={this.deleteTodayCard}
            createTomorrowItemCard={this.createTomorrowItemCard}
            createCalendarCard={this.createCalendarCard}
            pressTodayCard={this.pressTodayCard}
          />
        ))}
      </div>
    )
  }

  renderTaskItems = cards => {
    return (
      <div className={styles.sectionContainer}>
        <div className={styles.sectionTitle}>Tasks</div>
        {cards.map(card => (
          <TasksCard
            key={card._id}
            name={card.name}
            id={card._id}
            order={card.order}
            section={card.section}
            checkCard={this.checkTomorrowCard}
            shiftCard={this.shiftTomorrowCard}
            deleteCard={this.deleteTomorrowCard}
            moveToSectionCard={this.moveToSectionCard}
            createCalendarCard={this.createCalendarCard}
            pressTasksCard={this.pressTasksCard}
          />
        ))}
      </div>
    )
  }

  renderLogItems = cards => {
    return (
      <div className={styles.sectionContainer}>
        <div className={styles.sectionTitle}>Log</div>
        {cards.map(card => (
          <LogCard
            key={card.logId}
            name={card.name}
            id={card.logId}
            status={
              card.occurences[card.occurences.length - 1]
                ? card.occurences[card.occurences.length - 1].status
                : null
            }
            startedAt={card.startedAt}
            playCard={this.playCard}
            viewDetailsCard={this.viewDetailsCard}
          />
        ))}
      </div>
    )
  }

  render() {
    const {
      isModalOpen,
      isCalendarModal,
      isEventFormModal,
      modalName,
      modalDatetime,
      modalDuration,
      csvData,
      csvFilename,
    } = this.state
    const { search } = this.props
    const { todayItems, tomorrowItems, logItems } = search.toJS()
    // console.log(todayItems, tomorrowItems, logItems)

    const calendars = [
      {
        name: 'Google Calendar',
        function: () => this.handleCalendarClick('gcal'),
        icon: 'fa fa-google',
      },
      {
        name: 'Outlook Calendar',
        function: () => this.handleCalendarClick('outlook'),
        icon: 'fa fa-windows',
      },
      {
        name: 'Apple Calendar',
        function: () => this.handleCalendarClick('apple'),
        icon: 'fa fa-apple',
      },
    ]

    return (
      <div className={classnames(styles.main)}>
        <button
          style={{ position: 'absolute', top: 30, right: 25 }}
          className={classnames(styles.backButton)}
          type="submit"
          onClick={() => browserHistory.goBack()}
        >
          <i className="fa fa-times" />
        </button>
        <div style={{ color: 'white', fontSize: 20 }}>{`Search Results`}</div>
        <div className={classnames(styles.content)}>
          {todayItems.length > 0 && this.renderTodayItems(todayItems)}
          {tomorrowItems.length > 0 && this.renderTaskItems(tomorrowItems)}
          {logItems.length > 0 && this.renderLogItems(logItems)}
        </div>
        <div>
          <button className={classnames(styles.actionButton)} onClick={this.onExportClick}>
            Export
          </button>
        </div>
        <CSVLink
          data={csvData}
          ref={ele => (this.csvLink = ele)}
          filename={csvFilename}
          target="_blank"
        />
        <Modal
          isOpen={isModalOpen}
          className={classnames(styles.modal)}
          overlayClassName={classnames(styles.overlay)}
          onRequestClose={this.resetState}
          shouldCloseOnOverlayClick
          bodyOpenClassName={classnames(styles['disable-body-scroll'])}
        >
          {isCalendarModal && <CalendarModal calendars={calendars} />}
          {isEventFormModal && (
            <EventFormModal
              nameValue={modalName}
              nameOnChange={this.onNameChange}
              dateValue={modalDatetime}
              dateOnChange={this.onDatetimeChange}
              durationValue={modalDuration}
              durationOnChange={this.onDurationChange}
              button1Name="SAVE"
              button2Name="CANCEL"
              button1Function={this.onConfirmModal}
              button2Function={this.resetState}
            />
          )}
        </Modal>
      </div>
    )
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Search)



// WEBPACK FOOTER //
// ./src/views/search/index.js